import styled from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { bodyStyle, type TextStyleType } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { EcoBadge } from "../../../../../../../common-deprecated/styles/toyota/Badge";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.space[3]}px;
    min-width: 100%;
    padding: ${theme.space[3]}px;
    background-color: ${theme.colors.primaryWhite};
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.16);
    scroll-snap-align: start;

    @media ${getBreakpoint("up", "md")} {
        width: calc(50% - 12px);
        min-width: auto;
    }

    @media ${getBreakpoint("up", "lg")} {
        width: calc(33.333% - 20px);
    }
`;

export const Title = styled.h2<TextStyleType>`
    ${bodyStyle};
    margin: 0;
    text-transform: none;
    color: ${theme.colors.primaryBlack};
`;

export const TransmissionDescription = styled.div<{ isSmall?: boolean }>`
    ${bodyStyle}
    margin-top: ${theme.space[1]}px;
    color: ${theme.colors.grey4};
`;

export const PriceWrapper = styled.div``;

export const Header = styled.div`
    position: relative;
    width: 100%;
    padding-bottom: ${theme.space[3]}px;
    border-bottom: 1px solid ${theme.colors.grey2};

    /* Style position EcoBadge in header */
    ${EcoBadge} {
        position: absolute;
        top: 0;
        right: 0;
    }
`;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
`;
